import type { insuranceCoverageApiSpec } from "@wingspanhq/wingspan-api-types";
import { insuranceCoverageService } from "./service";

type IInsuranceCoverage = insuranceCoverageApiSpec.InsuranceCoverage;

export const getInsuranceCoverage = async (
  insuranceCoverageId: string
): Promise<IInsuranceCoverage> => {
  const { data } = await insuranceCoverageService.get<IInsuranceCoverage>(
    `/${insuranceCoverageId}`
  );
  return data;
};
